import { render, staticRenderFns } from "./LoanGuarantors.vue?vue&type=template&id=229ac8da"
import script from "./LoanGuarantors.vue?vue&type=script&lang=js"
export * from "./LoanGuarantors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports